<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="17.741" height="16.245" viewBox="0 0 17.741 16.245">
		<path
			id="Path_29845"
			data-name="Path 29845"
			d="M1.977,9.823,9.146,2.65a.9.9,0,0,1,1.274,0L17.6,9.823M3.779,8.021v8.11a.9.9,0,0,0,.9.9h3.3v-3.9a.9.9,0,0,1,.9-.9h1.8a.9.9,0,0,1,.9.9v3.9h3.3a.9.9,0,0,0,.9-.9V8.021M6.783,17.032h6.608"
			transform="translate(-0.917 -1.537)"
			fill="none"
			stroke="#727995"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="1"
		/>
	</svg>
</template>
<script>
export default { name: 'HomeSVG' };
</script>
